import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { legal } from "../legal";

export default function Legal({ doc }) {
  const [lang, setLang] = useState("it");
  const content = legal[lang][doc];

  useEffect(() => {
    document.title = `${content.title} · Villa Navagero Holiday Homes`;
    window.scrollTo(0, 0);
  }, [content.title]);

  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid={`legal-${doc}-page`}>
      <div className="noise-overlay" />
      <header className="border-b border-[#C29B62]/20 bg-[#F7F5F0]/90 backdrop-blur-xl sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <a href="/" data-testid="legal-back-home" className="font-serif-display text-xl tracking-tight text-[#1C3829]">
            Villa Navagero
          </a>
          <div className="flex items-center gap-1 text-xs uppercase tracking-widest" data-testid="legal-language-switcher">
            <button
              data-testid="legal-lang-it"
              onClick={() => setLang("it")}
              className={`px-2 py-1 transition-colors ${lang === "it" ? "text-[#1C3829] font-semibold" : "text-[#1A1A1A]/40 hover:text-[#1C3829]"}`}
            >
              IT
            </button>
            <span className="text-[#C29B62]">/</span>
            <button
              data-testid="legal-lang-en"
              onClick={() => setLang("en")}
              className={`px-2 py-1 transition-colors ${lang === "en" ? "text-[#1C3829] font-semibold" : "text-[#1A1A1A]/40 hover:text-[#1C3829]"}`}
            >
              EN
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 lg:py-24">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="text-xs uppercase tracking-[0.35em] text-[#C29B62]">Villa Navagero Holiday Homes</p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight text-[#1C3829]" data-testid="legal-title">
            {content.title}
          </h1>
          <p className="mt-4 text-base text-[#4A4A4A] font-light">{content.subtitle}</p>
          <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/40">{content.updated}</p>
        </motion.div>

        <div className="mt-12 space-y-10">
          {content.sections.map((s, i) => (
            <motion.section
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6 }}
              className="border-t border-[#C29B62]/25 pt-8"
              data-testid={`legal-section-${i}`}
            >
              <h2 className="text-xl lg:text-2xl font-light tracking-tight text-[#1C3829]">{s.h}</h2>
              <p className="mt-3 text-base text-[#4A4A4A] font-light leading-relaxed">{s.body}</p>
            </motion.section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[#C29B62]/25 flex flex-wrap gap-6 text-xs uppercase tracking-[0.2em]">
          <a href="/privacy" data-testid="legal-link-privacy" className={`transition-colors ${doc === "privacy" ? "text-[#1C3829] font-semibold" : "text-[#1A1A1A]/50 hover:text-[#1C3829]"}`}>
            Privacy Policy
          </a>
          <a href="/cookie-policy" data-testid="legal-link-cookie" className={`transition-colors ${doc === "cookie" ? "text-[#1C3829] font-semibold" : "text-[#1A1A1A]/50 hover:text-[#1C3829]"}`}>
            Cookie Policy
          </a>
          <a href="/" data-testid="legal-link-site" className="text-[#1A1A1A]/50 hover:text-[#1C3829] transition-colors">
            ← {lang === "it" ? "Torna al sito" : "Back to the site"}
          </a>
        </div>
      </main>
    </div>
  );
}
